var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategyCapitalPreserve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3025_51043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9809 0.549789C18.7404 0.448468 18.4635 0.505101 18.2785 0.689523L17.7447 1.22328C17.2579 1.7093 16.7792 1.78978 16.156 1.78978C13.8974 1.78978 11.9575 3.10003 11 4.98877C10.0445 3.10424 8.18069 1.78978 5.62293 1.78978C5.10618 1.78978 4.62094 1.58835 4.25523 1.22328L3.72155 0.68948C3.53649 0.505058 3.26144 0.449671 3.01914 0.549746C2.77809 0.649175 2.62134 0.884602 2.62134 1.14516V2.43419C2.62134 5.63283 5.22332 8.23481 8.42196 8.23481H10.3555V10.9206C8.34105 11.0256 6.4884 11.625 6.4884 12.8323C6.4884 14.1679 8.75424 14.7659 11 14.7659C13.2458 14.7659 15.5116 14.1679 15.5116 12.8323C15.5116 11.6251 13.6589 11.0256 11.6445 10.9206V8.23481H13.5781C16.7767 8.23481 19.3787 5.63283 19.3787 2.43419V1.14516C19.3786 0.884602 19.2219 0.649218 18.9809 0.549789Z",
    fill: "#D9D2FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 18.6329C9.02997 18.6329 7.49182 18.2477 6.48828 17.5796V17.9884C6.48828 19.324 8.75411 19.9219 10.9999 19.9219C13.2456 19.9219 15.5115 19.324 15.5115 17.9884V17.5796C14.508 18.2477 12.9698 18.6329 10.9999 18.6329Z",
    fill: "#523FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 21.2111C9.02995 21.2111 7.4918 20.8258 6.48826 20.1578C6.48826 20.3728 6.46403 20.644 6.54498 20.8266C6.82836 21.9742 8.91059 22.5001 10.9999 22.5001C12.5492 22.5001 15.5115 22.1075 15.5115 20.5665V20.1577C14.508 20.8258 12.9698 21.2111 10.9999 21.2111Z",
    fill: "#523FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 16.0548C9.02997 16.0548 7.49182 15.6695 6.48828 15.0015V15.4103C6.48828 16.7459 8.75411 17.3438 10.9999 17.3438C13.2456 17.3438 15.5115 16.7459 15.5115 15.4103V15.0015C14.508 15.6696 12.9698 16.0548 10.9999 16.0548Z",
    fill: "#523FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55481 12.1877C2.30913 12.1877 0.000244141 12.7857 0.000244141 14.1213C0.000244141 15.4569 2.30905 16.0549 4.55481 16.0549C4.77056 16.0549 4.98527 16.0442 5.19934 16.0331V12.2096C4.98527 12.1984 4.77056 12.1877 4.55481 12.1877Z",
    fill: "#523FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4451 12.1877C17.2293 12.1877 17.0146 12.1984 16.8005 12.2095V16.033C17.0146 16.0442 17.2293 16.0548 17.4451 16.0548C19.6908 16.0548 21.9996 15.4569 21.9996 14.1213C21.9996 12.7857 19.6908 12.1877 17.4451 12.1877Z",
    fill: "#523FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55481 17.3438C2.58491 17.3438 1.00378 16.9586 0.000244141 16.2905V16.6993C0.000244141 18.0349 2.30905 18.6329 4.55481 18.6329C4.77056 18.6329 4.98527 18.6223 5.19934 18.6111V17.3112C4.98347 17.3213 4.78233 17.3438 4.55481 17.3438Z",
    fill: "#523FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55481 19.9219C2.58491 19.9219 1.00378 19.5367 0.000244141 18.8687V19.2775C0.000244141 20.613 2.30909 21.211 4.55481 21.211C4.77056 21.211 4.98527 21.2004 5.19934 21.1892V19.8893C4.98347 19.8994 4.78233 19.9219 4.55481 19.9219Z",
    fill: "#523FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4451 17.3439C17.2175 17.3439 17.0165 17.3214 16.8005 17.3112V18.6111C17.0146 18.6223 17.2293 18.6329 17.4451 18.6329C19.6908 18.6329 21.9996 18.0349 21.9996 16.6993V16.2905C20.9961 16.9587 19.4149 17.3439 17.4451 17.3439Z",
    fill: "#523FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4451 19.922C17.2175 19.922 17.0165 19.8995 16.8005 19.8893V21.1892C17.0146 21.2004 17.2293 21.211 17.4451 21.211C19.6908 21.211 21.9996 20.6131 21.9996 19.2775V18.8687C20.9961 19.5368 19.4149 19.922 17.4451 19.922Z",
    fill: "#523FC0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3025_51043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyCapitalPreserve);
export default __webpack_public_path__ + "static/media/strategy-capital-preserve.8ca779081bdaf07b9f84807461a9cc94.svg";
export { ForwardRef as ReactComponent };